import { ApolloClient, gql, QueryLazyOptions, useLazyQuery } from '@apollo/client'
import { createContext, useContext, useMemo } from 'react'

interface Profile {
  userId: string;
  mid: string;
  displayName: string;
  avatarUrl?: string;
}

interface ProfileContent {
  profile: Profile;
  refresh: (options?: QueryLazyOptions<unknown>) => void;
}

const ProfileContext = createContext<ProfileContent>({
  profile: null,
  refresh: () => undefined
})

export default ProfileContext

const PROFILE_QUERY = gql`
  query {
    me {
      userId
      mid
      displayName
      avatarUrl
    }
  }
`

const useProfile = () => useContext(ProfileContext)

const useProfileContent = (client: ApolloClient<unknown>): ProfileContent => {
  const [refresh, { data, error }] = useLazyQuery(PROFILE_QUERY, {
    client,
    ssr: false
  })

  return useMemo(() => {
    const profile =
      typeof error === 'undefined' && typeof data === 'undefined'
        ? undefined
        : data?.me ?? null

    return {
      profile,
      refresh
    }
  }, [data, error, refresh])
}

export { useProfileContent, useProfile }
